/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `Date` scalar represents an ISO-8601 compliant date type. */
  Date: any;
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: any;
  /** Paragraph ID */
  ParaId: any;
  URL: any;
  UUID: any;
};

export enum ApplyPolicy {
  AfterResolver = 'AFTER_RESOLVER',
  BeforeResolver = 'BEFORE_RESOLVER',
  Validation = 'VALIDATION'
}

/** A segment of a collection. */
export type AuthorsCollectionSegment = {
  __typename?: 'AuthorsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PublicationAuthorDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Bible metadata */
export type BibleMetadata = {
  __typename?: 'BibleMetadata';
  /** Bible book */
  book: Scalars['String'];
  /** Bible chapter */
  chapter: Scalars['Int'];
  /** Bible verse */
  verses: Array<Scalars['Int']>;
};

/** Bible metadata */
export type BibleMetadataFilterInput = {
  and?: InputMaybe<Array<BibleMetadataFilterInput>>;
  /** Bible book */
  book?: InputMaybe<StringOperationFilterInput>;
  /** Bible chapter */
  chapter?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<BibleMetadataFilterInput>>;
  /** Bible verse */
  verses?: InputMaybe<ListIntOperationFilterInput>;
};

/** Bible metadata */
export type BibleMetadataSortInput = {
  /** Bible book */
  book?: InputMaybe<SortEnumType>;
  /** Bible chapter */
  chapter?: InputMaybe<SortEnumType>;
};

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']>;
  neq?: InputMaybe<Scalars['Boolean']>;
};

/** Information about the offset pagination. */
export type CollectionSegmentInfo = {
  __typename?: 'CollectionSegmentInfo';
  /** Indicates whether more items exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean'];
  /** Indicates whether more items exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean'];
};

export type CreateRootFolderForLanguageInput = {
  /** Language code */
  languageCode: Scalars['String'];
};

export type CreateRootFolderForLanguagePayload = {
  __typename?: 'CreateRootFolderForLanguagePayload';
  languageDto?: Maybe<LanguageDto>;
};

export type DateOperationFilterInput = {
  eq?: InputMaybe<Scalars['Date']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  neq?: InputMaybe<Scalars['Date']>;
  ngt?: InputMaybe<Scalars['Date']>;
  ngte?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  nlt?: InputMaybe<Scalars['Date']>;
  nlte?: InputMaybe<Scalars['Date']>;
};

export type DateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  neq?: InputMaybe<Scalars['DateTime']>;
  ngt?: InputMaybe<Scalars['DateTime']>;
  ngte?: InputMaybe<Scalars['DateTime']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  nlt?: InputMaybe<Scalars['DateTime']>;
  nlte?: InputMaybe<Scalars['DateTime']>;
};

/** Export files enum */
export enum ExportTypeEnum {
  /** EPub file */
  Epub = 'EPUB',
  /** Kindle Mobi file */
  Mobi = 'MOBI',
  /** Mp3 file */
  Mp3 = 'MP3',
  /** PDF File */
  Pdf = 'PDF'
}

export type ExportTypeEnumOperationFilterInput = {
  eq?: InputMaybe<ExportTypeEnum>;
  in?: InputMaybe<Array<ExportTypeEnum>>;
  neq?: InputMaybe<ExportTypeEnum>;
  nin?: InputMaybe<Array<ExportTypeEnum>>;
};

/**
 * Exported file
 * ExportedFile
 */
export type ExportedFileDto = {
  __typename?: 'ExportedFileDto';
  /** Created at */
  createdAt: Scalars['DateTime'];
  /** Exported filename */
  filename: Scalars['String'];
  /** Unique file identifier */
  id: Scalars['UUID'];
  /** Publication ID */
  publicationId: Scalars['Int'];
  /** Exported type enum */
  type: ExportTypeEnum;
  /** Updated at */
  updatedAt: Scalars['DateTime'];
};

/**
 * Exported file
 * ExportedFile
 */
export type ExportedFileDtoFilterInput = {
  and?: InputMaybe<Array<ExportedFileDtoFilterInput>>;
  /** Created at */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Exported filename */
  filename?: InputMaybe<StringOperationFilterInput>;
  /** Unique file identifier */
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<ExportedFileDtoFilterInput>>;
  /** Publication ID */
  publicationId?: InputMaybe<IntOperationFilterInput>;
  /** Exported type enum */
  type?: InputMaybe<ExportTypeEnumOperationFilterInput>;
  /** Updated at */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/**
 * Exported file
 * ExportedFile
 */
export type ExportedFileDtoSortInput = {
  /** Created at */
  createdAt?: InputMaybe<SortEnumType>;
  /** Exported filename */
  filename?: InputMaybe<SortEnumType>;
  /** Unique file identifier */
  id?: InputMaybe<SortEnumType>;
  /** Publication ID */
  publicationId?: InputMaybe<SortEnumType>;
  /** Exported type enum */
  type?: InputMaybe<SortEnumType>;
  /** Updated at */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type ExportedFilesCollectionSegment = {
  __typename?: 'ExportedFilesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ExportedFileDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** DTO for Folder */
export type FolderDto = {
  __typename?: 'FolderDto';
  /** Child folder count */
  childFolderCount: Scalars['Int'];
  /** Child publication count */
  childPublicationCount: Scalars['Int'];
  childPublicationCountRecursive: Scalars['Int'];
  /** Date of creation */
  createdAt: Scalars['DateTime'];
  /** Unique folder id */
  id: Scalars['Int'];
  /** Language */
  language?: Maybe<LanguageDto>;
  /** Order */
  order: Scalars['Int'];
  /** Folder parent ID */
  parentId?: Maybe<Scalars['Int']>;
  /** Child publications */
  publications?: Maybe<Array<Maybe<PublicationDto>>>;
  /** Title */
  title: Scalars['String'];
  /** Folder type */
  type?: Maybe<FolderTypeDto>;
  /** Folder type ID */
  typeId: Scalars['String'];
  /** Date of last modification */
  updatedAt: Scalars['DateTime'];
};

/** DTO for Folder */
export type FolderDtoFilterInput = {
  and?: InputMaybe<Array<FolderDtoFilterInput>>;
  /** Child folder count */
  childFolderCount?: InputMaybe<IntOperationFilterInput>;
  /** Child publication count */
  childPublicationCount?: InputMaybe<IntOperationFilterInput>;
  /** Date of creation */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Unique folder id */
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<FolderDtoFilterInput>>;
  /** Order */
  order?: InputMaybe<IntOperationFilterInput>;
  /** Folder parent ID */
  parentId?: InputMaybe<IntOperationFilterInput>;
  /** Title */
  title?: InputMaybe<StringOperationFilterInput>;
  /** Folder type ID */
  typeId?: InputMaybe<StringOperationFilterInput>;
  /** Date of last modification */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** DTO for Folder */
export type FolderDtoSortInput = {
  /** Child folder count */
  childFolderCount?: InputMaybe<SortEnumType>;
  /** Child publication count */
  childPublicationCount?: InputMaybe<SortEnumType>;
  /** Date of creation */
  createdAt?: InputMaybe<SortEnumType>;
  /** Unique folder id */
  id?: InputMaybe<SortEnumType>;
  /** Order */
  order?: InputMaybe<SortEnumType>;
  /** Folder parent ID */
  parentId?: InputMaybe<SortEnumType>;
  /** Title */
  title?: InputMaybe<SortEnumType>;
  /** Folder type ID */
  typeId?: InputMaybe<SortEnumType>;
  /** Date of last modification */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** DTO For FolderType */
export type FolderTypeDto = {
  __typename?: 'FolderTypeDto';
  /** Allowed publication types */
  allowedTypes: Array<PublicationType>;
  /** Created at */
  createdAt: Scalars['DateTime'];
  /** Folder type Id */
  id: Scalars['String'];
  /** Folder type name */
  title: Scalars['String'];
  /** Updated at */
  updatedAt: Scalars['DateTime'];
};

/** DTO For FolderType */
export type FolderTypeDtoFilterInput = {
  /** Allowed publication types */
  allowedTypes?: InputMaybe<ListPublicationTypeOperationFilterInput>;
  and?: InputMaybe<Array<FolderTypeDtoFilterInput>>;
  /** Created at */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Folder type Id */
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FolderTypeDtoFilterInput>>;
  /** Folder type name */
  title?: InputMaybe<StringOperationFilterInput>;
  /** Updated at */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** DTO For FolderType */
export type FolderTypeDtoSortInput = {
  /** Created at */
  createdAt?: InputMaybe<SortEnumType>;
  /** Folder type Id */
  id?: InputMaybe<SortEnumType>;
  /** Folder type name */
  title?: InputMaybe<SortEnumType>;
  /** Updated at */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** Publication-related mutations */
export type GraphQlMutations = {
  __typename?: 'GraphQlMutations';
  /** Create a new root folder for a language */
  createRootFolderForLanguage: CreateRootFolderForLanguagePayload;
  /** Sets ISBN code for a publication */
  publicationSetAuthor: PublicationSetAuthorPayload;
  /** Sets ISBN code for a publication */
  publicationSetIsbnCode: PublicationSetIsbnCodePayload;
  /** Updates publication */
  publicationUpdateDetails: PublicationUpdateDetailsPayload;
  /** Unpublishes a publication */
  publishPublication: PublishPublicationPayload;
  /** Recalculates global order for folders */
  recalculateOrders: RecalculateOrdersPayload;
  recalculatePublication: RecalculatePublicationPayload;
  /** Sets publication permissions */
  setPublicationOrder: SetPublicationOrderPayload;
  /** Sets publication permissions */
  setPublicationPermissions: SetPublicationPermissionsPayload;
  /** Unpublishes a publication */
  unpublishPublication: UnpublishPublicationPayload;
};


/** Publication-related mutations */
export type GraphQlMutationsCreateRootFolderForLanguageArgs = {
  input: CreateRootFolderForLanguageInput;
};


/** Publication-related mutations */
export type GraphQlMutationsPublicationSetAuthorArgs = {
  input: PublicationSetAuthorInput;
};


/** Publication-related mutations */
export type GraphQlMutationsPublicationSetIsbnCodeArgs = {
  input: PublicationSetIsbnCodeInput;
};


/** Publication-related mutations */
export type GraphQlMutationsPublicationUpdateDetailsArgs = {
  input: PublicationUpdateDetailsInput;
};


/** Publication-related mutations */
export type GraphQlMutationsPublishPublicationArgs = {
  input: PublishPublicationInput;
};


/** Publication-related mutations */
export type GraphQlMutationsRecalculatePublicationArgs = {
  input: RecalculatePublicationInput;
};


/** Publication-related mutations */
export type GraphQlMutationsSetPublicationOrderArgs = {
  input: SetPublicationOrderInput;
};


/** Publication-related mutations */
export type GraphQlMutationsSetPublicationPermissionsArgs = {
  input: SetPublicationPermissionsInput;
};


/** Publication-related mutations */
export type GraphQlMutationsUnpublishPublicationArgs = {
  input: UnpublishPublicationInput;
};

/** Queue extensions */
export type GraphQlQueries = {
  __typename?: 'GraphQlQueries';
  authors?: Maybe<AuthorsCollectionSegment>;
  exportedFiles?: Maybe<ExportedFilesCollectionSegment>;
  folder?: Maybe<FolderDto>;
  folderTypes: Array<FolderTypeDto>;
  folders: Array<FolderDto>;
  languages: Array<LanguageDto>;
  orderedParagraphs?: Maybe<Array<ParagraphDto>>;
  paragraphs?: Maybe<ParagraphsCollectionSegment>;
  publication?: Maybe<PublicationDto>;
  publicationChapters?: Maybe<PublicationChaptersCollectionSegment>;
  publicationMp3Files?: Maybe<PublicationMp3FilesCollectionSegment>;
  publicationSeries?: Maybe<PublicationSeriesCollectionSegment>;
  publications?: Maybe<PublicationsCollectionSegment>;
  /** Queue-related stats */
  queue: QueueNamespace;
};


/** Queue extensions */
export type GraphQlQueriesAuthorsArgs = {
  order?: InputMaybe<Array<PublicationAuthorDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PublicationAuthorDtoFilterInput>;
};


/** Queue extensions */
export type GraphQlQueriesExportedFilesArgs = {
  order?: InputMaybe<Array<ExportedFileDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ExportedFileDtoFilterInput>;
};


/** Queue extensions */
export type GraphQlQueriesFolderArgs = {
  folderId: Scalars['Int'];
};


/** Queue extensions */
export type GraphQlQueriesFolderTypesArgs = {
  order?: InputMaybe<Array<FolderTypeDtoSortInput>>;
  where?: InputMaybe<FolderTypeDtoFilterInput>;
};


/** Queue extensions */
export type GraphQlQueriesFoldersArgs = {
  order?: InputMaybe<Array<FolderDtoSortInput>>;
  where?: InputMaybe<FolderDtoFilterInput>;
};


/** Queue extensions */
export type GraphQlQueriesLanguagesArgs = {
  order?: InputMaybe<Array<LanguageDtoSortInput>>;
  where?: InputMaybe<LanguageDtoFilterInput>;
};


/** Queue extensions */
export type GraphQlQueriesOrderedParagraphsArgs = {
  offset?: InputMaybe<Scalars['Int']>;
  paraId: Scalars['ParaId'];
  take?: InputMaybe<Scalars['Int']>;
};


/** Queue extensions */
export type GraphQlQueriesParagraphsArgs = {
  order?: InputMaybe<Array<ParagraphDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ParagraphDtoFilterInput>;
};


/** Queue extensions */
export type GraphQlQueriesPublicationArgs = {
  publicationId: Scalars['Int'];
};


/** Queue extensions */
export type GraphQlQueriesPublicationChaptersArgs = {
  order?: InputMaybe<Array<PublicationChapterDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PublicationChapterDtoFilterInput>;
};


/** Queue extensions */
export type GraphQlQueriesPublicationMp3FilesArgs = {
  order?: InputMaybe<Array<PublicationMp3FileDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PublicationMp3FileDtoFilterInput>;
};


/** Queue extensions */
export type GraphQlQueriesPublicationSeriesArgs = {
  order?: InputMaybe<Array<PublicationSeriesDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PublicationSeriesDtoFilterInput>;
};


/** Queue extensions */
export type GraphQlQueriesPublicationsArgs = {
  order?: InputMaybe<Array<PublicationDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PublicationDtoFilterInput>;
};

export type IntOperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  neq?: InputMaybe<Scalars['Int']>;
  ngt?: InputMaybe<Scalars['Int']>;
  ngte?: InputMaybe<Scalars['Int']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  nlt?: InputMaybe<Scalars['Int']>;
  nlte?: InputMaybe<Scalars['Int']>;
};

/** DTO for Language */
export type LanguageDto = {
  __typename?: 'LanguageDto';
  /** BCP47 code (en-US) */
  bcp47Code: Scalars['String'];
  /** Unique publication code (eng) */
  code: Scalars['String'];
  /** Created at */
  createdAt: Scalars['DateTime'];
  /** EGW 2 (3) letter code (en) */
  egwCode: Scalars['String'];
  /** Is right to left */
  isRightToLeft: Scalars['Boolean'];
  rootFolder?: Maybe<FolderDto>;
  /** Root folder Id */
  rootFolderId?: Maybe<Scalars['Int']>;
  /** Language title */
  title: Scalars['String'];
  /** Updated at */
  updatedAt: Scalars['DateTime'];
};

/** DTO for Language */
export type LanguageDtoFilterInput = {
  and?: InputMaybe<Array<LanguageDtoFilterInput>>;
  /** BCP47 code (en-US) */
  bcp47Code?: InputMaybe<StringOperationFilterInput>;
  /** Unique publication code (eng) */
  code?: InputMaybe<StringOperationFilterInput>;
  /** Created at */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** EGW 2 (3) letter code (en) */
  egwCode?: InputMaybe<StringOperationFilterInput>;
  /** Is right to left */
  isRightToLeft?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<LanguageDtoFilterInput>>;
  /** Root folder Id */
  rootFolderId?: InputMaybe<IntOperationFilterInput>;
  /** Language title */
  title?: InputMaybe<StringOperationFilterInput>;
  /** Updated at */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** DTO for Language */
export type LanguageDtoSortInput = {
  /** BCP47 code (en-US) */
  bcp47Code?: InputMaybe<SortEnumType>;
  /** Unique publication code (eng) */
  code?: InputMaybe<SortEnumType>;
  /** Created at */
  createdAt?: InputMaybe<SortEnumType>;
  /** EGW 2 (3) letter code (en) */
  egwCode?: InputMaybe<SortEnumType>;
  /** Is right to left */
  isRightToLeft?: InputMaybe<SortEnumType>;
  /** Root folder Id */
  rootFolderId?: InputMaybe<SortEnumType>;
  /** Language title */
  title?: InputMaybe<SortEnumType>;
  /** Updated at */
  updatedAt?: InputMaybe<SortEnumType>;
};

export type ListIntOperationFilterInput = {
  all?: InputMaybe<IntOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<IntOperationFilterInput>;
  some?: InputMaybe<IntOperationFilterInput>;
};

export type ListPublicationTypeOperationFilterInput = {
  all?: InputMaybe<PublicationTypeOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<PublicationTypeOperationFilterInput>;
  some?: InputMaybe<PublicationTypeOperationFilterInput>;
};

/** Metadata for letters/manuscripts */
export type LtMsMetadata = {
  __typename?: 'LtMsMetadata';
  /** Manuscript addressee */
  addressee?: Maybe<Scalars['String']>;
  /** Manuscript place */
  place?: Maybe<Scalars['String']>;
  /** Manuscript title */
  title?: Maybe<Scalars['String']>;
};

/** Metadata for letters/manuscripts */
export type LtMsMetadataFilterInput = {
  /** Manuscript addressee */
  addressee?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<LtMsMetadataFilterInput>>;
  or?: InputMaybe<Array<LtMsMetadataFilterInput>>;
  /** Manuscript place */
  place?: InputMaybe<StringOperationFilterInput>;
  /** Manuscript title */
  title?: InputMaybe<StringOperationFilterInput>;
};

/** Metadata for letters/manuscripts */
export type LtMsMetadataSortInput = {
  /** Manuscript addressee */
  addressee?: InputMaybe<SortEnumType>;
  /** Manuscript place */
  place?: InputMaybe<SortEnumType>;
  /** Manuscript title */
  title?: InputMaybe<SortEnumType>;
};

/** Pagination metadata */
export type PaginationMetaData = {
  __typename?: 'PaginationMetaData';
  /** Pagination paragraph */
  paragraph: Scalars['Int'];
  /** Pagination section */
  section: Scalars['String'];
};

/** Pagination metadata */
export type PaginationMetaDataFilterInput = {
  and?: InputMaybe<Array<PaginationMetaDataFilterInput>>;
  or?: InputMaybe<Array<PaginationMetaDataFilterInput>>;
  /** Pagination paragraph */
  paragraph?: InputMaybe<IntOperationFilterInput>;
  /** Pagination section */
  section?: InputMaybe<StringOperationFilterInput>;
};

/** Pagination metadata */
export type PaginationMetaDataSortInput = {
  /** Pagination paragraph */
  paragraph?: InputMaybe<SortEnumType>;
  /** Pagination section */
  section?: InputMaybe<SortEnumType>;
};

export type ParaIdFilterInputType = {
  eq?: InputMaybe<Scalars['ParaId']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ParaId']>>>;
  neq?: InputMaybe<Scalars['ParaId']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['ParaId']>>>;
};

/** Paragraph DTO */
export type ParagraphDto = {
  __typename?: 'ParagraphDto';
  /** Bible metadata */
  bibleMetadata?: Maybe<BibleMetadata>;
  /** Paragraph content */
  content: Scalars['String'];
  /** Created at */
  createdAt: Scalars['DateTime'];
  /** Paragraph date */
  date?: Maybe<Scalars['Date']>;
  /** End date for paragraph */
  endDate?: Maybe<Scalars['Date']>;
  /** Heading level: null for pages, 0 for paragraphs, 1 for headings, 2 for subheadings, etc. */
  headingLevel?: Maybe<Scalars['Int']>;
  /** Is referenced */
  isReferenced: Scalars['Boolean'];
  /** Has manuscript metadata */
  ltMsMetadata?: Maybe<LtMsMetadata>;
  /** Paragraph order (unique in book) */
  order: Scalars['Int'];
  /** Pagination section */
  pagination?: Maybe<PaginationMetaData>;
  /** Paragraph ID (unique key) */
  paraId: Scalars['ParaId'];
  /** Paragraph ID (unique in book) */
  paragraphId: Scalars['Int'];
  /** Publication id */
  publicationId: Scalars['Int'];
  /** Long reference code */
  refCodeLong?: Maybe<Scalars['String']>;
  /** Short reference code */
  refCodeShort?: Maybe<Scalars['String']>;
  /** Updated at */
  updatedAt: Scalars['DateTime'];
};

/** Paragraph DTO */
export type ParagraphDtoFilterInput = {
  and?: InputMaybe<Array<ParagraphDtoFilterInput>>;
  /** Bible metadata */
  bibleMetadata?: InputMaybe<BibleMetadataFilterInput>;
  /** Paragraph content */
  content?: InputMaybe<StringOperationFilterInput>;
  /** Created at */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Paragraph date */
  date?: InputMaybe<DateOperationFilterInput>;
  /** End date for paragraph */
  endDate?: InputMaybe<DateOperationFilterInput>;
  /** Heading level: null for pages, 0 for paragraphs, 1 for headings, 2 for subheadings, etc. */
  headingLevel?: InputMaybe<IntOperationFilterInput>;
  /** Is referenced */
  isReferenced?: InputMaybe<BooleanOperationFilterInput>;
  /** Has manuscript metadata */
  ltMsMetadata?: InputMaybe<LtMsMetadataFilterInput>;
  or?: InputMaybe<Array<ParagraphDtoFilterInput>>;
  /** Paragraph order (unique in book) */
  order?: InputMaybe<IntOperationFilterInput>;
  /** Pagination section */
  pagination?: InputMaybe<PaginationMetaDataFilterInput>;
  /** Paragraph ID (unique key) */
  paraId?: InputMaybe<ParaIdFilterInputType>;
  /** Paragraph ID (unique in book) */
  paragraphId?: InputMaybe<IntOperationFilterInput>;
  /** Publication id */
  publicationId?: InputMaybe<IntOperationFilterInput>;
  /** Long reference code */
  refCodeLong?: InputMaybe<StringOperationFilterInput>;
  /** Short reference code */
  refCodeShort?: InputMaybe<StringOperationFilterInput>;
  /** Updated at */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** Paragraph DTO */
export type ParagraphDtoSortInput = {
  /** Bible metadata */
  bibleMetadata?: InputMaybe<BibleMetadataSortInput>;
  /** Paragraph content */
  content?: InputMaybe<SortEnumType>;
  /** Created at */
  createdAt?: InputMaybe<SortEnumType>;
  /** Paragraph date */
  date?: InputMaybe<SortEnumType>;
  /** End date for paragraph */
  endDate?: InputMaybe<SortEnumType>;
  /** Heading level: null for pages, 0 for paragraphs, 1 for headings, 2 for subheadings, etc. */
  headingLevel?: InputMaybe<SortEnumType>;
  /** Is referenced */
  isReferenced?: InputMaybe<SortEnumType>;
  /** Has manuscript metadata */
  ltMsMetadata?: InputMaybe<LtMsMetadataSortInput>;
  /** Paragraph order (unique in book) */
  order?: InputMaybe<SortEnumType>;
  /** Pagination section */
  pagination?: InputMaybe<PaginationMetaDataSortInput>;
  /** Paragraph ID (unique key) */
  paraId?: InputMaybe<SortEnumType>;
  /** Paragraph ID (unique in book) */
  paragraphId?: InputMaybe<SortEnumType>;
  /** Publication id */
  publicationId?: InputMaybe<SortEnumType>;
  /** Long reference code */
  refCodeLong?: InputMaybe<SortEnumType>;
  /** Short reference code */
  refCodeShort?: InputMaybe<SortEnumType>;
  /** Updated at */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type ParagraphsCollectionSegment = {
  __typename?: 'ParagraphsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ParagraphDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/**
 * Publication author
 * PublicationAuthor
 */
export type PublicationAuthorDto = {
  __typename?: 'PublicationAuthorDto';
  /** Author biography */
  biography?: Maybe<Scalars['String']>;
  /** Birth year */
  birthYear?: Maybe<Scalars['Int']>;
  /** Author code */
  code?: Maybe<Scalars['String']>;
  /** Created at */
  createdAt: Scalars['DateTime'];
  /** Death year */
  deathYear?: Maybe<Scalars['Int']>;
  /** First name */
  firstName: Scalars['String'];
  /** Unique author ID */
  id: Scalars['Int'];
  /** Last name */
  lastName: Scalars['String'];
  /** Middle name */
  middleName: Scalars['String'];
  /** Updated at */
  updatedAt: Scalars['DateTime'];
};

/**
 * Publication author
 * PublicationAuthor
 */
export type PublicationAuthorDtoFilterInput = {
  and?: InputMaybe<Array<PublicationAuthorDtoFilterInput>>;
  /** Author biography */
  biography?: InputMaybe<StringOperationFilterInput>;
  /** Birth year */
  birthYear?: InputMaybe<IntOperationFilterInput>;
  /** Author code */
  code?: InputMaybe<StringOperationFilterInput>;
  /** Created at */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Death year */
  deathYear?: InputMaybe<IntOperationFilterInput>;
  /** First name */
  firstName?: InputMaybe<StringOperationFilterInput>;
  /** Unique author ID */
  id?: InputMaybe<IntOperationFilterInput>;
  /** Last name */
  lastName?: InputMaybe<StringOperationFilterInput>;
  /** Middle name */
  middleName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PublicationAuthorDtoFilterInput>>;
  /** Updated at */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/**
 * Publication author
 * PublicationAuthor
 */
export type PublicationAuthorDtoSortInput = {
  /** Author biography */
  biography?: InputMaybe<SortEnumType>;
  /** Birth year */
  birthYear?: InputMaybe<SortEnumType>;
  /** Author code */
  code?: InputMaybe<SortEnumType>;
  /** Created at */
  createdAt?: InputMaybe<SortEnumType>;
  /** Death year */
  deathYear?: InputMaybe<SortEnumType>;
  /** First name */
  firstName?: InputMaybe<SortEnumType>;
  /** Unique author ID */
  id?: InputMaybe<SortEnumType>;
  /** Last name */
  lastName?: InputMaybe<SortEnumType>;
  /** Middle name */
  middleName?: InputMaybe<SortEnumType>;
  /** Updated at */
  updatedAt?: InputMaybe<SortEnumType>;
};

/**
 * Publication chapter
 * PublicationChapter
 */
export type PublicationChapterDto = {
  __typename?: 'PublicationChapterDto';
  /** Chapter identifier */
  chapterId: Scalars['ParaId'];
  /** Created at */
  createdAt: Scalars['DateTime'];
  /** Chapter level */
  level: Scalars['Int'];
  /** Chapter order */
  order: Scalars['Int'];
  /** Starting paragraph ID for a chapter */
  paraId: Scalars['ParaId'];
  /** Chapter title paragraph */
  paragraph?: Maybe<ParagraphDto>;
  /** Publication id */
  publicationId: Scalars['Int'];
  /** Chapter title */
  title: Scalars['String'];
  /** Updated at */
  updatedAt: Scalars['DateTime'];
};

/**
 * Publication chapter
 * PublicationChapter
 */
export type PublicationChapterDtoFilterInput = {
  and?: InputMaybe<Array<PublicationChapterDtoFilterInput>>;
  /** Chapter identifier */
  chapterId?: InputMaybe<ParaIdFilterInputType>;
  /** Created at */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Chapter level */
  level?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<PublicationChapterDtoFilterInput>>;
  /** Chapter order */
  order?: InputMaybe<IntOperationFilterInput>;
  /** Starting paragraph ID for a chapter */
  paraId?: InputMaybe<ParaIdFilterInputType>;
  /** Publication id */
  publicationId?: InputMaybe<IntOperationFilterInput>;
  /** Chapter title */
  title?: InputMaybe<StringOperationFilterInput>;
  /** Updated at */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/**
 * Publication chapter
 * PublicationChapter
 */
export type PublicationChapterDtoSortInput = {
  /** Chapter identifier */
  chapterId?: InputMaybe<SortEnumType>;
  /** Created at */
  createdAt?: InputMaybe<SortEnumType>;
  /** Chapter level */
  level?: InputMaybe<SortEnumType>;
  /** Chapter order */
  order?: InputMaybe<SortEnumType>;
  /** Starting paragraph ID for a chapter */
  paraId?: InputMaybe<SortEnumType>;
  /** Publication id */
  publicationId?: InputMaybe<SortEnumType>;
  /** Chapter title */
  title?: InputMaybe<SortEnumType>;
  /** Updated at */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type PublicationChaptersCollectionSegment = {
  __typename?: 'PublicationChaptersCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PublicationChapterDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** DTO for Publication */
export type PublicationDto = {
  __typename?: 'PublicationDto';
  /** Publication author */
  author?: Maybe<PublicationAuthorDto>;
  /** Publication author */
  authorId?: Maybe<Scalars['Int']>;
  /** Publication chapters */
  chapters?: Maybe<Array<PublicationChapterDto>>;
  /** Publication code */
  code: Scalars['String'];
  /** Created at */
  createdAt: Scalars['DateTime'];
  /** Publication description */
  description: Scalars['String'];
  /** Folder ID */
  folderId?: Maybe<Scalars['Int']>;
  /** ISBN Code */
  isbn?: Maybe<Scalars['String']>;
  /** Publication language */
  language?: Maybe<LanguageDto>;
  /** Language code */
  languageCode: Scalars['String'];
  /** Publication mp3 files */
  mp3Files?: Maybe<Array<PublicationMp3FileDto>>;
  /** Order in folder */
  order: Scalars['Int'];
  /** Original publication */
  originalPublication?: Maybe<PublicationDto>;
  /** Original publication ID */
  originalPublicationId?: Maybe<Scalars['Int']>;
  /** Page count */
  pageCount?: Maybe<Scalars['Int']>;
  /** Paragraphs */
  paragraphs?: Maybe<Array<Maybe<ParagraphDto>>>;
  /** Permission */
  permission: PublicationPermissionEnum;
  /** Publication ID */
  publicationId: Scalars['Int'];
  /** Year of publication */
  publicationYear?: Maybe<Scalars['Int']>;
  /** Publisher */
  publisher: Scalars['String'];
  /** Purchase URI */
  purchaseLink?: Maybe<Scalars['URL']>;
  /** Publication title */
  title: Scalars['String'];
  /** Publication type */
  type: PublicationType;
  /** Updated at */
  updatedAt: Scalars['DateTime'];
};


/** DTO for Publication */
export type PublicationDtoParagraphsArgs = {
  offset?: InputMaybe<Scalars['Int']>;
  start: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
};

/** DTO for Publication */
export type PublicationDtoFilterInput = {
  and?: InputMaybe<Array<PublicationDtoFilterInput>>;
  /** Publication author */
  authorId?: InputMaybe<IntOperationFilterInput>;
  /** Publication code */
  code?: InputMaybe<StringOperationFilterInput>;
  /** Created at */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Publication description */
  description?: InputMaybe<StringOperationFilterInput>;
  /** Folder ID */
  folderId?: InputMaybe<IntOperationFilterInput>;
  /** ISBN Code */
  isbn?: InputMaybe<StringOperationFilterInput>;
  /** Language code */
  languageCode?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PublicationDtoFilterInput>>;
  /** Order in folder */
  order?: InputMaybe<IntOperationFilterInput>;
  /** Original publication ID */
  originalPublicationId?: InputMaybe<IntOperationFilterInput>;
  /** Page count */
  pageCount?: InputMaybe<IntOperationFilterInput>;
  /** Permission */
  permission?: InputMaybe<PublicationPermissionEnumOperationFilterInput>;
  /** Publication ID */
  publicationId?: InputMaybe<IntOperationFilterInput>;
  /** Year of publication */
  publicationYear?: InputMaybe<IntOperationFilterInput>;
  /** Publisher */
  publisher?: InputMaybe<StringOperationFilterInput>;
  /** Purchase URI */
  purchaseLink?: InputMaybe<UrlOperationFilterInput>;
  /** Publication title */
  title?: InputMaybe<StringOperationFilterInput>;
  /** Publication type */
  type?: InputMaybe<PublicationTypeOperationFilterInput>;
  /** Updated at */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** DTO for Publication */
export type PublicationDtoSortInput = {
  /** Publication author */
  authorId?: InputMaybe<SortEnumType>;
  /** Publication code */
  code?: InputMaybe<SortEnumType>;
  /** Created at */
  createdAt?: InputMaybe<SortEnumType>;
  /** Publication description */
  description?: InputMaybe<SortEnumType>;
  /** Folder ID */
  folderId?: InputMaybe<SortEnumType>;
  /** ISBN Code */
  isbn?: InputMaybe<SortEnumType>;
  /** Language code */
  languageCode?: InputMaybe<SortEnumType>;
  /** Order in folder */
  order?: InputMaybe<SortEnumType>;
  /** Original publication ID */
  originalPublicationId?: InputMaybe<SortEnumType>;
  /** Page count */
  pageCount?: InputMaybe<SortEnumType>;
  /** Permission */
  permission?: InputMaybe<SortEnumType>;
  /** Publication ID */
  publicationId?: InputMaybe<SortEnumType>;
  /** Year of publication */
  publicationYear?: InputMaybe<SortEnumType>;
  /** Publisher */
  publisher?: InputMaybe<SortEnumType>;
  /** Purchase URI */
  purchaseLink?: InputMaybe<UriSortInput>;
  /** Publication title */
  title?: InputMaybe<SortEnumType>;
  /** Publication type */
  type?: InputMaybe<SortEnumType>;
  /** Updated at */
  updatedAt?: InputMaybe<SortEnumType>;
};

/**
 * Mp3 File
 * Mp3File
 */
export type PublicationMp3FileDto = {
  __typename?: 'PublicationMp3FileDto';
  /** Created at */
  createdAt: Scalars['DateTime'];
  /** Element Id */
  elementId: Scalars['Int'];
  /** Mp3 File Name */
  filename: Scalars['String'];
  /** Voice is autogenerated */
  isGenerated: Scalars['Boolean'];
  /** Id */
  paraId: Scalars['ParaId'];
  /** Publication Id */
  publicationId: Scalars['Int'];
  /** Updated at */
  updatedAt: Scalars['DateTime'];
  /** Voice type */
  voiceType: VoiceTypeEnum;
};

/**
 * Mp3 File
 * Mp3File
 */
export type PublicationMp3FileDtoFilterInput = {
  and?: InputMaybe<Array<PublicationMp3FileDtoFilterInput>>;
  /** Created at */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Element Id */
  elementId?: InputMaybe<IntOperationFilterInput>;
  /** Mp3 File Name */
  filename?: InputMaybe<StringOperationFilterInput>;
  /** Voice is autogenerated */
  isGenerated?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<PublicationMp3FileDtoFilterInput>>;
  /** Id */
  paraId?: InputMaybe<ParaIdFilterInputType>;
  /** Publication Id */
  publicationId?: InputMaybe<IntOperationFilterInput>;
  /** Updated at */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Voice type */
  voiceType?: InputMaybe<VoiceTypeEnumOperationFilterInput>;
};

/**
 * Mp3 File
 * Mp3File
 */
export type PublicationMp3FileDtoSortInput = {
  /** Created at */
  createdAt?: InputMaybe<SortEnumType>;
  /** Element Id */
  elementId?: InputMaybe<SortEnumType>;
  /** Mp3 File Name */
  filename?: InputMaybe<SortEnumType>;
  /** Voice is autogenerated */
  isGenerated?: InputMaybe<SortEnumType>;
  /** Id */
  paraId?: InputMaybe<SortEnumType>;
  /** Publication Id */
  publicationId?: InputMaybe<SortEnumType>;
  /** Updated at */
  updatedAt?: InputMaybe<SortEnumType>;
  /** Voice type */
  voiceType?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type PublicationMp3FilesCollectionSegment = {
  __typename?: 'PublicationMp3FilesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PublicationMp3FileDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Publication permission */
export enum PublicationPermissionEnum {
  /** Must me authorized */
  AuthenticatedOnly = 'AUTHENTICATED_ONLY',
  /** Publication is hidden from export */
  Hidden = 'HIDDEN',
  /** Publication is public */
  Public = 'PUBLIC',
  /** Must be purchased */
  PurchasedOnly = 'PURCHASED_ONLY'
}

export type PublicationPermissionEnumOperationFilterInput = {
  eq?: InputMaybe<PublicationPermissionEnum>;
  in?: InputMaybe<Array<PublicationPermissionEnum>>;
  neq?: InputMaybe<PublicationPermissionEnum>;
  nin?: InputMaybe<Array<PublicationPermissionEnum>>;
};

/** A segment of a collection. */
export type PublicationSeriesCollectionSegment = {
  __typename?: 'PublicationSeriesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PublicationSeriesDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/**
 * Publications series DTO
 * PublicationSeries
 */
export type PublicationSeriesDto = {
  __typename?: 'PublicationSeriesDto';
  /** Series code */
  code: Scalars['String'];
  /** Created at */
  createdAt: Scalars['DateTime'];
  /** List of publications in series */
  publications: Array<Scalars['Int']>;
  /** Series title */
  title: Scalars['String'];
  /** Series type */
  type: SeriesTypeEnum;
  /** Updated at */
  updatedAt: Scalars['DateTime'];
};

/**
 * Publications series DTO
 * PublicationSeries
 */
export type PublicationSeriesDtoFilterInput = {
  and?: InputMaybe<Array<PublicationSeriesDtoFilterInput>>;
  /** Series code */
  code?: InputMaybe<StringOperationFilterInput>;
  /** Created at */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<PublicationSeriesDtoFilterInput>>;
  /** List of publications in series */
  publications?: InputMaybe<ListIntOperationFilterInput>;
  /** Series title */
  title?: InputMaybe<StringOperationFilterInput>;
  /** Series type */
  type?: InputMaybe<SeriesTypeEnumOperationFilterInput>;
  /** Updated at */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/**
 * Publications series DTO
 * PublicationSeries
 */
export type PublicationSeriesDtoSortInput = {
  /** Series code */
  code?: InputMaybe<SortEnumType>;
  /** Created at */
  createdAt?: InputMaybe<SortEnumType>;
  /** Series title */
  title?: InputMaybe<SortEnumType>;
  /** Series type */
  type?: InputMaybe<SortEnumType>;
  /** Updated at */
  updatedAt?: InputMaybe<SortEnumType>;
};

export type PublicationSetAuthorInput = {
  /** Publication author ID */
  authorId?: InputMaybe<Scalars['Int']>;
  /** Publication ID */
  publicationId: Scalars['Int'];
};

export type PublicationSetAuthorPayload = {
  __typename?: 'PublicationSetAuthorPayload';
  publicationDto?: Maybe<PublicationDto>;
};

export type PublicationSetIsbnCodeInput = {
  /** ISBN code */
  isbn: Scalars['String'];
  /** Publication ID */
  publicationId: Scalars['Int'];
};

export type PublicationSetIsbnCodePayload = {
  __typename?: 'PublicationSetIsbnCodePayload';
  publicationDto?: Maybe<PublicationDto>;
};

export enum PublicationType {
  Bible = 'BIBLE',
  BibleCommentary = 'BIBLE_COMMENTARY',
  Book = 'BOOK',
  Devotional = 'DEVOTIONAL',
  Dictionary = 'DICTIONARY',
  Manuscript = 'MANUSCRIPT',
  PeriodicalNoPageBreak = 'PERIODICAL_NO_PAGE_BREAK',
  PeriodicalPageBreak = 'PERIODICAL_PAGE_BREAK',
  ScriptureIndex = 'SCRIPTURE_INDEX',
  TopicalIndex = 'TOPICAL_INDEX'
}

export type PublicationTypeOperationFilterInput = {
  eq?: InputMaybe<PublicationType>;
  in?: InputMaybe<Array<PublicationType>>;
  neq?: InputMaybe<PublicationType>;
  nin?: InputMaybe<Array<PublicationType>>;
};

export type PublicationUpdateDetailsInput = {
  /** Details */
  details: SetPublicationDetailsInput;
  /** Publication ID */
  publicationId: Scalars['Int'];
};

export type PublicationUpdateDetailsPayload = {
  __typename?: 'PublicationUpdateDetailsPayload';
  publicationDto?: Maybe<PublicationDto>;
};

/** A segment of a collection. */
export type PublicationsCollectionSegment = {
  __typename?: 'PublicationsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PublicationDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type PublishPublicationInput = {
  /** Folder id */
  folderId: Scalars['Int'];
  /** Publication ID */
  publicationId: Scalars['Int'];
};

export type PublishPublicationPayload = {
  __typename?: 'PublishPublicationPayload';
  publicationDto?: Maybe<PublicationDto>;
};

/** Queue log entry */
export type QueueLogEntry = {
  __typename?: 'QueueLogEntry';
  /** Duration in milliseconds */
  durationMs: Scalars['Int'];
  /** Error message */
  error?: Maybe<Scalars['String']>;
  /** File size */
  fileSize: Scalars['Int'];
  /** Date and time of processing */
  processedAt: Scalars['DateTime'];
  /** Publication id */
  publicationId: Scalars['Int'];
};

/** Queue-related queries */
export type QueueNamespace = {
  __typename?: 'QueueNamespace';
  /** Queue size */
  log: Array<QueueLogEntry>;
  /** Queue size */
  queueSize: Scalars['Int'];
};

export type RecalculateOrdersPayload = {
  __typename?: 'RecalculateOrdersPayload';
  boolean?: Maybe<Scalars['Boolean']>;
};

export type RecalculatePublicationInput = {
  publicationId: Scalars['Int'];
};

export type RecalculatePublicationPayload = {
  __typename?: 'RecalculatePublicationPayload';
  boolean?: Maybe<Scalars['Boolean']>;
};

/** Series type */
export enum SeriesTypeEnum {
  /** Series */
  Series = 'SERIES',
  /** Topic */
  Topic = 'TOPIC'
}

export type SeriesTypeEnumOperationFilterInput = {
  eq?: InputMaybe<SeriesTypeEnum>;
  in?: InputMaybe<Array<SeriesTypeEnum>>;
  neq?: InputMaybe<SeriesTypeEnum>;
  nin?: InputMaybe<Array<SeriesTypeEnum>>;
};

/** Set publication details */
export type SetPublicationDetailsInput = {
  /** Publication code */
  code: Scalars['String'];
  /** Publication description */
  description: Scalars['String'];
  /** Page count */
  pageCount?: InputMaybe<Scalars['Int']>;
  /** Publication year */
  publicationYear?: InputMaybe<Scalars['Int']>;
  /** Publisher */
  publisher: Scalars['String'];
  /** Purchase link */
  purchaseLink?: InputMaybe<Scalars['URL']>;
  /** Publication title */
  title: Scalars['String'];
};

export type SetPublicationOrderInput = {
  /** New order */
  order: Scalars['Float'];
  /** Publication ID */
  publicationId: Scalars['Int'];
};

export type SetPublicationOrderPayload = {
  __typename?: 'SetPublicationOrderPayload';
  publicationDto?: Maybe<PublicationDto>;
};

export type SetPublicationPermissionsInput = {
  /** New permission */
  permission: PublicationPermissionEnum;
  /** Publication ID */
  publicationId: Scalars['Int'];
};

export type SetPublicationPermissionsPayload = {
  __typename?: 'SetPublicationPermissionsPayload';
  publicationDto?: Maybe<PublicationDto>;
};

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  eq?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ncontains?: InputMaybe<Scalars['String']>;
  nendsWith?: InputMaybe<Scalars['String']>;
  neq?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nstartsWith?: InputMaybe<Scalars['String']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type UnpublishPublicationInput = {
  /** Publication ID */
  publicationId: Scalars['Int'];
};

export type UnpublishPublicationPayload = {
  __typename?: 'UnpublishPublicationPayload';
  publicationDto?: Maybe<PublicationDto>;
};

export type UriSortInput = {
  absolutePath?: InputMaybe<SortEnumType>;
  absoluteUri?: InputMaybe<SortEnumType>;
  authority?: InputMaybe<SortEnumType>;
  dnsSafeHost?: InputMaybe<SortEnumType>;
  fragment?: InputMaybe<SortEnumType>;
  host?: InputMaybe<SortEnumType>;
  hostNameType?: InputMaybe<SortEnumType>;
  idnHost?: InputMaybe<SortEnumType>;
  isAbsoluteUri?: InputMaybe<SortEnumType>;
  isDefaultPort?: InputMaybe<SortEnumType>;
  isFile?: InputMaybe<SortEnumType>;
  isLoopback?: InputMaybe<SortEnumType>;
  isUnc?: InputMaybe<SortEnumType>;
  localPath?: InputMaybe<SortEnumType>;
  originalString?: InputMaybe<SortEnumType>;
  pathAndQuery?: InputMaybe<SortEnumType>;
  port?: InputMaybe<SortEnumType>;
  query?: InputMaybe<SortEnumType>;
  scheme?: InputMaybe<SortEnumType>;
  userEscaped?: InputMaybe<SortEnumType>;
  userInfo?: InputMaybe<SortEnumType>;
};

export type UrlOperationFilterInput = {
  eq?: InputMaybe<Scalars['URL']>;
  gt?: InputMaybe<Scalars['URL']>;
  gte?: InputMaybe<Scalars['URL']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['URL']>>>;
  lt?: InputMaybe<Scalars['URL']>;
  lte?: InputMaybe<Scalars['URL']>;
  neq?: InputMaybe<Scalars['URL']>;
  ngt?: InputMaybe<Scalars['URL']>;
  ngte?: InputMaybe<Scalars['URL']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['URL']>>>;
  nlt?: InputMaybe<Scalars['URL']>;
  nlte?: InputMaybe<Scalars['URL']>;
};

export type UuidOperationFilterInput = {
  eq?: InputMaybe<Scalars['UUID']>;
  gt?: InputMaybe<Scalars['UUID']>;
  gte?: InputMaybe<Scalars['UUID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  lt?: InputMaybe<Scalars['UUID']>;
  lte?: InputMaybe<Scalars['UUID']>;
  neq?: InputMaybe<Scalars['UUID']>;
  ngt?: InputMaybe<Scalars['UUID']>;
  ngte?: InputMaybe<Scalars['UUID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  nlt?: InputMaybe<Scalars['UUID']>;
  nlte?: InputMaybe<Scalars['UUID']>;
};

/** Voice type */
export enum VoiceTypeEnum {
  /** Female voice */
  Female = 'FEMALE',
  /** Male voice */
  Male = 'MALE'
}

export type VoiceTypeEnumOperationFilterInput = {
  eq?: InputMaybe<VoiceTypeEnum>;
  in?: InputMaybe<Array<VoiceTypeEnum>>;
  neq?: InputMaybe<VoiceTypeEnum>;
  nin?: InputMaybe<Array<VoiceTypeEnum>>;
};

export type RecalculateGlobalFolderPositionsMutationVariables = Exact<{ [key: string]: never; }>;


export type RecalculateGlobalFolderPositionsMutation = { __typename?: 'GraphQlMutations', recalculateOrders: { __typename?: 'RecalculateOrdersPayload', boolean?: boolean | null } };

export type FilterPublicationsForExportFragmentFragment = { __typename?: 'PublicationDto', publicationId: number, code: string, languageCode: string, title: string } & { ' $fragmentName'?: 'FilterPublicationsForExportFragmentFragment' };

export type FilterPublicationsForExportQueryVariables = Exact<{
  where?: InputMaybe<PublicationDtoFilterInput>;
}>;


export type FilterPublicationsForExportQuery = { __typename?: 'GraphQlQueries', publications?: { __typename?: 'PublicationsCollectionSegment', items?: Array<(
      { __typename?: 'PublicationDto' }
      & { ' $fragmentRefs'?: { 'FilterPublicationsForExportFragmentFragment': FilterPublicationsForExportFragmentFragment } }
    )> | null } | null };

export type QueueLogEntryFragment = { __typename?: 'QueueLogEntry', publicationId: number, fileSize: number, processedAt: any, durationMs: number, error?: string | null } & { ' $fragmentName'?: 'QueueLogEntryFragment' };

export type GetQueueStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQueueStatsQuery = { __typename?: 'GraphQlQueries', queue: { __typename?: 'QueueNamespace', queueSize: number } };

export type GetQueueLogQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQueueLogQuery = { __typename?: 'GraphQlQueries', queue: { __typename?: 'QueueNamespace', log: Array<(
      { __typename?: 'QueueLogEntry' }
      & { ' $fragmentRefs'?: { 'QueueLogEntryFragment': QueueLogEntryFragment } }
    )> } };

export type AddPublicationPageFolderTypeDtoFragment = { __typename?: 'FolderTypeDto', id: string, title: string, allowedTypes: Array<PublicationType> } & { ' $fragmentName'?: 'AddPublicationPageFolderTypeDtoFragment' };

export type AddPublicationPageFolderDtoFragment = { __typename?: 'FolderDto', id: number, title: string, childFolderCount: number, type?: (
    { __typename?: 'FolderTypeDto' }
    & { ' $fragmentRefs'?: { 'AddPublicationPageFolderTypeDtoFragment': AddPublicationPageFolderTypeDtoFragment } }
  ) | null, language?: { __typename?: 'LanguageDto', code: string } | null } & { ' $fragmentName'?: 'AddPublicationPageFolderDtoFragment' };

export type AddPublicationPagePublicationDtoFragment = { __typename?: 'PublicationDto', publicationId: number, code: string, title: string, type: PublicationType } & { ' $fragmentName'?: 'AddPublicationPagePublicationDtoFragment' };

export type GetPublicationPageDetailsQueryVariables = Exact<{
  folderId: Scalars['Int'];
}>;


export type GetPublicationPageDetailsQuery = { __typename?: 'GraphQlQueries', folder?: (
    { __typename?: 'FolderDto' }
    & { ' $fragmentRefs'?: { 'AddPublicationPageFolderDtoFragment': AddPublicationPageFolderDtoFragment } }
  ) | null };

export type GetUnpublishedPublicationsForFolderQueryVariables = Exact<{
  languageCode: Scalars['String'];
  types: Array<PublicationType>;
}>;


export type GetUnpublishedPublicationsForFolderQuery = { __typename?: 'GraphQlQueries', publications?: { __typename?: 'PublicationsCollectionSegment', totalCount: number, items?: Array<(
      { __typename?: 'PublicationDto' }
      & { ' $fragmentRefs'?: { 'AddPublicationPagePublicationDtoFragment': AddPublicationPagePublicationDtoFragment } }
    )> | null } | null };

export type GetUnpublishedPublicationsForLanguageQueryVariables = Exact<{
  languageCode: Scalars['String'];
}>;


export type GetUnpublishedPublicationsForLanguageQuery = { __typename?: 'GraphQlQueries', publications?: { __typename?: 'PublicationsCollectionSegment', totalCount: number, items?: Array<(
      { __typename?: 'PublicationDto' }
      & { ' $fragmentRefs'?: { 'AddPublicationPagePublicationDtoFragment': AddPublicationPagePublicationDtoFragment } }
    )> | null } | null };

export type CreateRootFolderForLanguageMutationVariables = Exact<{
  languageCode: Scalars['String'];
}>;


export type CreateRootFolderForLanguageMutation = { __typename?: 'GraphQlMutations', createRootFolderForLanguage: { __typename?: 'CreateRootFolderForLanguagePayload', languageDto?: (
      { __typename?: 'LanguageDto' }
      & { ' $fragmentRefs'?: { 'LanguageDtoFragment': LanguageDtoFragment } }
    ) | null } };

export type ChangePublicationPermissionMutationVariables = Exact<{
  publicationId: Scalars['Int'];
  permission: PublicationPermissionEnum;
}>;


export type ChangePublicationPermissionMutation = { __typename?: 'GraphQlMutations', setPublicationPermissions: { __typename?: 'SetPublicationPermissionsPayload', publicationDto?: (
      { __typename?: 'PublicationDto' }
      & { ' $fragmentRefs'?: { 'TreePublicationDtoFragment': TreePublicationDtoFragment } }
    ) | null } };

export type ChangePublicationOrderMutationVariables = Exact<{
  publicationId: Scalars['Int'];
  order: Scalars['Float'];
}>;


export type ChangePublicationOrderMutation = { __typename?: 'GraphQlMutations', setPublicationOrder: { __typename?: 'SetPublicationOrderPayload', publicationDto?: (
      { __typename?: 'PublicationDto' }
      & { ' $fragmentRefs'?: { 'TreePublicationDtoFragment': TreePublicationDtoFragment } }
    ) | null } };

export type UnpublishPublicationMutationVariables = Exact<{
  publicationId: Scalars['Int'];
}>;


export type UnpublishPublicationMutation = { __typename?: 'GraphQlMutations', unpublishPublication: { __typename?: 'UnpublishPublicationPayload', publicationDto?: (
      { __typename?: 'PublicationDto' }
      & { ' $fragmentRefs'?: { 'TreePublicationDtoFragment': TreePublicationDtoFragment } }
    ) | null } };

export type PublishPublicationMutationVariables = Exact<{
  publicationId: Scalars['Int'];
  folderId: Scalars['Int'];
}>;


export type PublishPublicationMutation = { __typename?: 'GraphQlMutations', publishPublication: { __typename?: 'PublishPublicationPayload', publicationDto?: (
      { __typename?: 'PublicationDto' }
      & { ' $fragmentRefs'?: { 'TreePublicationDtoFragment': TreePublicationDtoFragment } }
    ) | null } };

export type LanguageDtoFragment = { __typename?: 'LanguageDto', code: string, bcp47Code: string, egwCode: string, isRightToLeft: boolean, title: string, createdAt: any, rootFolder?: (
    { __typename?: 'FolderDto' }
    & { ' $fragmentRefs'?: { 'RootFolderDtoFragment': RootFolderDtoFragment } }
  ) | null } & { ' $fragmentName'?: 'LanguageDtoFragment' };

export type TreePublicationDtoFragment = { __typename?: 'PublicationDto', publicationId: number, languageCode: string, code: string, title: string, order: number, permission: PublicationPermissionEnum, type: PublicationType } & { ' $fragmentName'?: 'TreePublicationDtoFragment' };

export type RootFolderDtoFragment = { __typename?: 'FolderDto', id: number, order: number, title: string, typeId: string, childFolderCount: number, childPublicationCountRecursive: number, createdAt: any, updatedAt: any } & { ' $fragmentName'?: 'RootFolderDtoFragment' };

export type ChildFolderDtoFragment = { __typename?: 'FolderDto', id: number, order: number, title: string, typeId: string, createdAt: any, updatedAt: any, childPublicationCount: number, childPublicationCountRecursive: number, childFolderCount: number, publications?: Array<(
    { __typename?: 'PublicationDto' }
    & { ' $fragmentRefs'?: { 'TreePublicationDtoFragment': TreePublicationDtoFragment } }
  ) | null> | null } & { ' $fragmentName'?: 'ChildFolderDtoFragment' };

export type ListLanguagesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListLanguagesQuery = { __typename?: 'GraphQlQueries', languages: Array<(
    { __typename?: 'LanguageDto' }
    & { ' $fragmentRefs'?: { 'LanguageDtoFragment': LanguageDtoFragment } }
  )> };

export type GetChildFoldersQueryVariables = Exact<{
  parent: Scalars['Int'];
}>;


export type GetChildFoldersQuery = { __typename?: 'GraphQlQueries', folders: Array<(
    { __typename?: 'FolderDto' }
    & { ' $fragmentRefs'?: { 'ChildFolderDtoFragment': ChildFolderDtoFragment } }
  )> };

export type PublicationViewPage_AuthorFragment = { __typename?: 'PublicationAuthorDto', id: number, firstName: string, middleName: string, lastName: string, code?: string | null } & { ' $fragmentName'?: 'PublicationViewPage_AuthorFragment' };

export type PublicationViewPage_OriginalPublicationFragment = { __typename?: 'PublicationDto', publicationId: number, code: string, title: string } & { ' $fragmentName'?: 'PublicationViewPage_OriginalPublicationFragment' };

export type PublicationViewPage_LanguageFragment = { __typename?: 'LanguageDto', code: string, title: string, isRightToLeft: boolean } & { ' $fragmentName'?: 'PublicationViewPage_LanguageFragment' };

export type PublicationViewPage_PublicationFragment = { __typename?: 'PublicationDto', publicationId: number, type: PublicationType, title: string, permission: PublicationPermissionEnum, code: string, updatedAt: any, createdAt: any, description: string, isbn?: string | null, pageCount?: number | null, publicationYear?: number | null, publisher: string, purchaseLink?: any | null, language?: (
    { __typename?: 'LanguageDto' }
    & { ' $fragmentRefs'?: { 'PublicationViewPage_LanguageFragment': PublicationViewPage_LanguageFragment } }
  ) | null, originalPublication?: (
    { __typename?: 'PublicationDto' }
    & { ' $fragmentRefs'?: { 'PublicationViewPage_OriginalPublicationFragment': PublicationViewPage_OriginalPublicationFragment } }
  ) | null, author?: (
    { __typename?: 'PublicationAuthorDto' }
    & { ' $fragmentRefs'?: { 'PublicationViewPage_AuthorFragment': PublicationViewPage_AuthorFragment } }
  ) | null } & { ' $fragmentName'?: 'PublicationViewPage_PublicationFragment' };

export type GetPublicationQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetPublicationQuery = { __typename?: 'GraphQlQueries', publication?: (
    { __typename?: 'PublicationDto' }
    & { ' $fragmentRefs'?: { 'PublicationViewPage_PublicationFragment': PublicationViewPage_PublicationFragment } }
  ) | null };

export type PublicationViewPage_ChapterFragment = { __typename?: 'PublicationChapterDto', level: number, title: string, chapterId: any, paraId: any, paragraph?: { __typename?: 'ParagraphDto', refCodeShort?: string | null } | null } & { ' $fragmentName'?: 'PublicationViewPage_ChapterFragment' };

export type PublicationViewPage_Mp3Fragment = { __typename?: 'PublicationMp3FileDto', paraId: any, filename: string, voiceType: VoiceTypeEnum, isGenerated: boolean } & { ' $fragmentName'?: 'PublicationViewPage_Mp3Fragment' };

export type PublicationViewPage_PublicationChapterDtoFragment = { __typename?: 'PublicationDto', chapters?: Array<(
    { __typename?: 'PublicationChapterDto' }
    & { ' $fragmentRefs'?: { 'PublicationViewPage_ChapterFragment': PublicationViewPage_ChapterFragment } }
  )> | null, mp3Files?: Array<(
    { __typename?: 'PublicationMp3FileDto' }
    & { ' $fragmentRefs'?: { 'PublicationViewPage_Mp3Fragment': PublicationViewPage_Mp3Fragment } }
  )> | null } & { ' $fragmentName'?: 'PublicationViewPage_PublicationChapterDtoFragment' };

export type PublicationGetChaptersQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type PublicationGetChaptersQuery = { __typename?: 'GraphQlQueries', publication?: (
    { __typename?: 'PublicationDto' }
    & { ' $fragmentRefs'?: { 'PublicationViewPage_PublicationChapterDtoFragment': PublicationViewPage_PublicationChapterDtoFragment } }
  ) | null };

export type PublicationEditForm_UpdatePublicationMutationVariables = Exact<{
  publicationId: Scalars['Int'];
  code: Scalars['String'];
  title: Scalars['String'];
  description: Scalars['String'];
  publisher: Scalars['String'];
  isbn: Scalars['String'];
  purchaseLink?: InputMaybe<Scalars['URL']>;
  pageCount?: InputMaybe<Scalars['Int']>;
  publicationYear?: InputMaybe<Scalars['Int']>;
  authorId?: InputMaybe<Scalars['Int']>;
}>;


export type PublicationEditForm_UpdatePublicationMutation = { __typename?: 'GraphQlMutations', publicationUpdateDetails: { __typename?: 'PublicationUpdateDetailsPayload', publicationDto?: { __typename?: 'PublicationDto', publicationId: number } | null }, publicationSetAuthor: { __typename?: 'PublicationSetAuthorPayload', publicationDto?: { __typename?: 'PublicationDto', publicationId: number } | null }, publicationSetIsbnCode: { __typename?: 'PublicationSetIsbnCodePayload', publicationDto?: { __typename?: 'PublicationDto', publicationId: number } | null } };

export type BookDetailsForReading__PublicationFragment = { __typename?: 'PublicationDto', publicationId: number, code: string, title: string } & { ' $fragmentName'?: 'BookDetailsForReading__PublicationFragment' };

export type BookDetailsForReading__ChapterFragment = { __typename?: 'PublicationChapterDto', paraId: any, title: string, level: number } & { ' $fragmentName'?: 'BookDetailsForReading__ChapterFragment' };

export type BookDetailsForReading__ParagraphFragment = { __typename?: 'ParagraphDto', paraId: any, content: string, refCodeShort?: string | null, order: number } & { ' $fragmentName'?: 'BookDetailsForReading__ParagraphFragment' };

export type GetBookDetailsForReadingQueryVariables = Exact<{
  publicationId: Scalars['Int'];
  elementId: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
  take: Scalars['Int'];
}>;


export type GetBookDetailsForReadingQuery = { __typename?: 'GraphQlQueries', publication?: (
    { __typename?: 'PublicationDto', chapters?: Array<(
      { __typename?: 'PublicationChapterDto' }
      & { ' $fragmentRefs'?: { 'BookDetailsForReading__ChapterFragment': BookDetailsForReading__ChapterFragment } }
    )> | null, paragraphs?: Array<(
      { __typename?: 'ParagraphDto' }
      & { ' $fragmentRefs'?: { 'BookDetailsForReading__ParagraphFragment': BookDetailsForReading__ParagraphFragment } }
    ) | null> | null }
    & { ' $fragmentRefs'?: { 'BookDetailsForReading__PublicationFragment': BookDetailsForReading__PublicationFragment } }
  ) | null };

export type LoadContentChunkQueryVariables = Exact<{
  publicationId: Scalars['Int'];
  elementId: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
  take: Scalars['Int'];
}>;


export type LoadContentChunkQuery = { __typename?: 'GraphQlQueries', publication?: { __typename?: 'PublicationDto', paragraphs?: Array<(
      { __typename?: 'ParagraphDto' }
      & { ' $fragmentRefs'?: { 'BookDetailsForReading__ParagraphFragment': BookDetailsForReading__ParagraphFragment } }
    ) | null> | null } | null };

export type AuthorSelector_PublicationAuthorFragment = { __typename?: 'PublicationAuthorDto', id: number, code?: string | null, firstName: string, middleName: string, lastName: string } & { ' $fragmentName'?: 'AuthorSelector_PublicationAuthorFragment' };

export type AuthorSelector_ListAuthorsQueryVariables = Exact<{ [key: string]: never; }>;


export type AuthorSelector_ListAuthorsQuery = { __typename?: 'GraphQlQueries', authors?: { __typename?: 'AuthorsCollectionSegment', items?: Array<(
      { __typename?: 'PublicationAuthorDto' }
      & { ' $fragmentRefs'?: { 'AuthorSelector_PublicationAuthorFragment': AuthorSelector_PublicationAuthorFragment } }
    )> | null } | null };

export const FilterPublicationsForExportFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FilterPublicationsForExportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublicationDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicationId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"languageCode"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]} as unknown as DocumentNode<FilterPublicationsForExportFragmentFragment, unknown>;
export const QueueLogEntryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QueueLogEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QueueLogEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicationId"}},{"kind":"Field","name":{"kind":"Name","value":"fileSize"}},{"kind":"Field","name":{"kind":"Name","value":"processedAt"}},{"kind":"Field","name":{"kind":"Name","value":"durationMs"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]} as unknown as DocumentNode<QueueLogEntryFragment, unknown>;
export const AddPublicationPageFolderTypeDtoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddPublicationPageFolderTypeDto"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FolderTypeDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"allowedTypes"}}]}}]} as unknown as DocumentNode<AddPublicationPageFolderTypeDtoFragment, unknown>;
export const AddPublicationPageFolderDtoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddPublicationPageFolderDto"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FolderDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddPublicationPageFolderTypeDto"}}]}},{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"childFolderCount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddPublicationPageFolderTypeDto"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FolderTypeDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"allowedTypes"}}]}}]} as unknown as DocumentNode<AddPublicationPageFolderDtoFragment, unknown>;
export const AddPublicationPagePublicationDtoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddPublicationPagePublicationDto"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublicationDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicationId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<AddPublicationPagePublicationDtoFragment, unknown>;
export const RootFolderDtoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RootFolderDto"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FolderDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"typeId"}},{"kind":"Field","name":{"kind":"Name","value":"childFolderCount"}},{"kind":"Field","name":{"kind":"Name","value":"childPublicationCountRecursive"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode<RootFolderDtoFragment, unknown>;
export const LanguageDtoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LanguageDto"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"bcp47Code"}},{"kind":"Field","name":{"kind":"Name","value":"egwCode"}},{"kind":"Field","name":{"kind":"Name","value":"isRightToLeft"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"rootFolder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RootFolderDto"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RootFolderDto"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FolderDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"typeId"}},{"kind":"Field","name":{"kind":"Name","value":"childFolderCount"}},{"kind":"Field","name":{"kind":"Name","value":"childPublicationCountRecursive"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode<LanguageDtoFragment, unknown>;
export const TreePublicationDtoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TreePublicationDto"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublicationDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicationId"}},{"kind":"Field","name":{"kind":"Name","value":"languageCode"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"permission"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<TreePublicationDtoFragment, unknown>;
export const ChildFolderDtoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChildFolderDto"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FolderDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"typeId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"childPublicationCount"}},{"kind":"Field","name":{"kind":"Name","value":"childPublicationCountRecursive"}},{"kind":"Field","name":{"kind":"Name","value":"childFolderCount"}},{"kind":"Field","name":{"kind":"Name","value":"publications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TreePublicationDto"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TreePublicationDto"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublicationDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicationId"}},{"kind":"Field","name":{"kind":"Name","value":"languageCode"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"permission"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<ChildFolderDtoFragment, unknown>;
export const PublicationViewPage_LanguageFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PublicationViewPage_Language"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"isRightToLeft"}}]}}]} as unknown as DocumentNode<PublicationViewPage_LanguageFragment, unknown>;
export const PublicationViewPage_OriginalPublicationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PublicationViewPage_OriginalPublication"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublicationDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicationId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]} as unknown as DocumentNode<PublicationViewPage_OriginalPublicationFragment, unknown>;
export const PublicationViewPage_AuthorFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PublicationViewPage_Author"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublicationAuthorDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"middleName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]} as unknown as DocumentNode<PublicationViewPage_AuthorFragment, unknown>;
export const PublicationViewPage_PublicationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PublicationViewPage_Publication"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublicationDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicationId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"permission"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isbn"}},{"kind":"Field","name":{"kind":"Name","value":"pageCount"}},{"kind":"Field","name":{"kind":"Name","value":"publicationYear"}},{"kind":"Field","name":{"kind":"Name","value":"publisher"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseLink"}},{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PublicationViewPage_Language"}}]}},{"kind":"Field","name":{"kind":"Name","value":"originalPublication"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PublicationViewPage_OriginalPublication"}}]}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PublicationViewPage_Author"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PublicationViewPage_Language"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"isRightToLeft"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PublicationViewPage_OriginalPublication"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublicationDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicationId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PublicationViewPage_Author"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublicationAuthorDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"middleName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]} as unknown as DocumentNode<PublicationViewPage_PublicationFragment, unknown>;
export const PublicationViewPage_ChapterFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PublicationViewPage_Chapter"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublicationChapterDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"chapterId"}},{"kind":"Field","name":{"kind":"Name","value":"paraId"}},{"kind":"Field","name":{"kind":"Name","value":"paragraph"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refCodeShort"}}]}}]}}]} as unknown as DocumentNode<PublicationViewPage_ChapterFragment, unknown>;
export const PublicationViewPage_Mp3FragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PublicationViewPage_Mp3"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublicationMp3FileDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paraId"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"voiceType"}},{"kind":"Field","name":{"kind":"Name","value":"isGenerated"}}]}}]} as unknown as DocumentNode<PublicationViewPage_Mp3Fragment, unknown>;
export const PublicationViewPage_PublicationChapterDtoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PublicationViewPage_PublicationChapterDto"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublicationDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chapters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PublicationViewPage_Chapter"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mp3Files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PublicationViewPage_Mp3"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PublicationViewPage_Chapter"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublicationChapterDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"chapterId"}},{"kind":"Field","name":{"kind":"Name","value":"paraId"}},{"kind":"Field","name":{"kind":"Name","value":"paragraph"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refCodeShort"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PublicationViewPage_Mp3"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublicationMp3FileDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paraId"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"voiceType"}},{"kind":"Field","name":{"kind":"Name","value":"isGenerated"}}]}}]} as unknown as DocumentNode<PublicationViewPage_PublicationChapterDtoFragment, unknown>;
export const BookDetailsForReading__PublicationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BookDetailsForReading__Publication"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublicationDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicationId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]} as unknown as DocumentNode<BookDetailsForReading__PublicationFragment, unknown>;
export const BookDetailsForReading__ChapterFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BookDetailsForReading__Chapter"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublicationChapterDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paraId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"level"}}]}}]} as unknown as DocumentNode<BookDetailsForReading__ChapterFragment, unknown>;
export const BookDetailsForReading__ParagraphFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BookDetailsForReading__Paragraph"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ParagraphDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paraId"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"refCodeShort"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]} as unknown as DocumentNode<BookDetailsForReading__ParagraphFragment, unknown>;
export const AuthorSelector_PublicationAuthorFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AuthorSelector_PublicationAuthor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublicationAuthorDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"middleName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]} as unknown as DocumentNode<AuthorSelector_PublicationAuthorFragment, unknown>;
export const RecalculateGlobalFolderPositionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RecalculateGlobalFolderPositions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recalculateOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"boolean"}}]}}]}}]} as unknown as DocumentNode<RecalculateGlobalFolderPositionsMutation, RecalculateGlobalFolderPositionsMutationVariables>;
export const FilterPublicationsForExportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FilterPublicationsForExport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PublicationDtoFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"publicationId"},"value":{"kind":"EnumValue","value":"ASC"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FilterPublicationsForExportFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FilterPublicationsForExportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublicationDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicationId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"languageCode"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]} as unknown as DocumentNode<FilterPublicationsForExportQuery, FilterPublicationsForExportQueryVariables>;
export const GetQueueStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetQueueStats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queueSize"}}]}}]}}]} as unknown as DocumentNode<GetQueueStatsQuery, GetQueueStatsQueryVariables>;
export const GetQueueLogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetQueueLog"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"log"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QueueLogEntry"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QueueLogEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QueueLogEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicationId"}},{"kind":"Field","name":{"kind":"Name","value":"fileSize"}},{"kind":"Field","name":{"kind":"Name","value":"processedAt"}},{"kind":"Field","name":{"kind":"Name","value":"durationMs"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]} as unknown as DocumentNode<GetQueueLogQuery, GetQueueLogQueryVariables>;
export const GetPublicationPageDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPublicationPageDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"folderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"folder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"folderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"folderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddPublicationPageFolderDto"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddPublicationPageFolderTypeDto"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FolderTypeDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"allowedTypes"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddPublicationPageFolderDto"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FolderDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddPublicationPageFolderTypeDto"}}]}},{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"childFolderCount"}}]}}]} as unknown as DocumentNode<GetPublicationPageDetailsQuery, GetPublicationPageDetailsQueryVariables>;
export const GetUnpublishedPublicationsForFolderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUnpublishedPublicationsForFolder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"types"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PublicationType"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"folderId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"NullValue"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"types"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddPublicationPagePublicationDto"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddPublicationPagePublicationDto"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublicationDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicationId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<GetUnpublishedPublicationsForFolderQuery, GetUnpublishedPublicationsForFolderQueryVariables>;
export const GetUnpublishedPublicationsForLanguageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUnpublishedPublicationsForLanguage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"folderId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"NullValue"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddPublicationPagePublicationDto"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddPublicationPagePublicationDto"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublicationDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicationId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<GetUnpublishedPublicationsForLanguageQuery, GetUnpublishedPublicationsForLanguageQueryVariables>;
export const CreateRootFolderForLanguageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateRootFolderForLanguage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createRootFolderForLanguage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"languageDto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LanguageDto"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RootFolderDto"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FolderDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"typeId"}},{"kind":"Field","name":{"kind":"Name","value":"childFolderCount"}},{"kind":"Field","name":{"kind":"Name","value":"childPublicationCountRecursive"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LanguageDto"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"bcp47Code"}},{"kind":"Field","name":{"kind":"Name","value":"egwCode"}},{"kind":"Field","name":{"kind":"Name","value":"isRightToLeft"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"rootFolder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RootFolderDto"}}]}}]}}]} as unknown as DocumentNode<CreateRootFolderForLanguageMutation, CreateRootFolderForLanguageMutationVariables>;
export const ChangePublicationPermissionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangePublicationPermission"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"publicationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"permission"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PublicationPermissionEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setPublicationPermissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"publicationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"publicationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"permission"},"value":{"kind":"Variable","name":{"kind":"Name","value":"permission"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicationDto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TreePublicationDto"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TreePublicationDto"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublicationDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicationId"}},{"kind":"Field","name":{"kind":"Name","value":"languageCode"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"permission"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<ChangePublicationPermissionMutation, ChangePublicationPermissionMutationVariables>;
export const ChangePublicationOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangePublicationOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"publicationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setPublicationOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"publicationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"publicationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicationDto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TreePublicationDto"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TreePublicationDto"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublicationDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicationId"}},{"kind":"Field","name":{"kind":"Name","value":"languageCode"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"permission"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<ChangePublicationOrderMutation, ChangePublicationOrderMutationVariables>;
export const UnpublishPublicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UnpublishPublication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"publicationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unpublishPublication"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"publicationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"publicationId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicationDto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TreePublicationDto"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TreePublicationDto"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublicationDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicationId"}},{"kind":"Field","name":{"kind":"Name","value":"languageCode"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"permission"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<UnpublishPublicationMutation, UnpublishPublicationMutationVariables>;
export const PublishPublicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PublishPublication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"publicationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"folderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publishPublication"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"publicationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"publicationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"folderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"folderId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicationDto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TreePublicationDto"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TreePublicationDto"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublicationDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicationId"}},{"kind":"Field","name":{"kind":"Name","value":"languageCode"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"permission"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<PublishPublicationMutation, PublishPublicationMutationVariables>;
export const ListLanguagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListLanguages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"languages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"eng","block":false},{"kind":"StringValue","value":"rus","block":false},{"kind":"StringValue","value":"ukr","block":false}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LanguageDto"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RootFolderDto"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FolderDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"typeId"}},{"kind":"Field","name":{"kind":"Name","value":"childFolderCount"}},{"kind":"Field","name":{"kind":"Name","value":"childPublicationCountRecursive"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LanguageDto"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"bcp47Code"}},{"kind":"Field","name":{"kind":"Name","value":"egwCode"}},{"kind":"Field","name":{"kind":"Name","value":"isRightToLeft"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"rootFolder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RootFolderDto"}}]}}]}}]} as unknown as DocumentNode<ListLanguagesQuery, ListLanguagesQueryVariables>;
export const GetChildFoldersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetChildFolders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parent"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"folders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parent"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChildFolderDto"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TreePublicationDto"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublicationDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicationId"}},{"kind":"Field","name":{"kind":"Name","value":"languageCode"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"permission"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChildFolderDto"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FolderDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"typeId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"childPublicationCount"}},{"kind":"Field","name":{"kind":"Name","value":"childPublicationCountRecursive"}},{"kind":"Field","name":{"kind":"Name","value":"childFolderCount"}},{"kind":"Field","name":{"kind":"Name","value":"publications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TreePublicationDto"}}]}}]}}]} as unknown as DocumentNode<GetChildFoldersQuery, GetChildFoldersQueryVariables>;
export const GetPublicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPublication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publication"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"publicationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PublicationViewPage_Publication"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PublicationViewPage_Language"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"isRightToLeft"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PublicationViewPage_OriginalPublication"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublicationDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicationId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PublicationViewPage_Author"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublicationAuthorDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"middleName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PublicationViewPage_Publication"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublicationDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicationId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"permission"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isbn"}},{"kind":"Field","name":{"kind":"Name","value":"pageCount"}},{"kind":"Field","name":{"kind":"Name","value":"publicationYear"}},{"kind":"Field","name":{"kind":"Name","value":"publisher"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseLink"}},{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PublicationViewPage_Language"}}]}},{"kind":"Field","name":{"kind":"Name","value":"originalPublication"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PublicationViewPage_OriginalPublication"}}]}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PublicationViewPage_Author"}}]}}]}}]} as unknown as DocumentNode<GetPublicationQuery, GetPublicationQueryVariables>;
export const PublicationGetChaptersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PublicationGetChapters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publication"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"publicationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PublicationViewPage_PublicationChapterDto"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PublicationViewPage_Chapter"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublicationChapterDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"chapterId"}},{"kind":"Field","name":{"kind":"Name","value":"paraId"}},{"kind":"Field","name":{"kind":"Name","value":"paragraph"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refCodeShort"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PublicationViewPage_Mp3"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublicationMp3FileDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paraId"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"voiceType"}},{"kind":"Field","name":{"kind":"Name","value":"isGenerated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PublicationViewPage_PublicationChapterDto"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublicationDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chapters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PublicationViewPage_Chapter"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mp3Files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PublicationViewPage_Mp3"}}]}}]}}]} as unknown as DocumentNode<PublicationGetChaptersQuery, PublicationGetChaptersQueryVariables>;
export const PublicationEditForm_UpdatePublicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PublicationEditForm_UpdatePublication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"publicationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"publisher"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isbn"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"purchaseLink"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"URL"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageCount"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"publicationYear"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"authorId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicationUpdateDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"publicationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"publicationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"details"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"publisher"},"value":{"kind":"Variable","name":{"kind":"Name","value":"publisher"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"purchaseLink"},"value":{"kind":"Variable","name":{"kind":"Name","value":"purchaseLink"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"pageCount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageCount"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"publicationYear"},"value":{"kind":"Variable","name":{"kind":"Name","value":"publicationYear"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicationDto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicationId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"publicationSetAuthor"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"publicationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"publicationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"authorId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"authorId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicationDto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicationId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"publicationSetIsbnCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"publicationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"publicationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"isbn"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isbn"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicationDto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicationId"}}]}}]}}]}}]} as unknown as DocumentNode<PublicationEditForm_UpdatePublicationMutation, PublicationEditForm_UpdatePublicationMutationVariables>;
export const GetBookDetailsForReadingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBookDetailsForReading"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"publicationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"elementId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publication"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"publicationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"publicationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BookDetailsForReading__Publication"}},{"kind":"Field","name":{"kind":"Name","value":"chapters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BookDetailsForReading__Chapter"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paragraphs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"elementId"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BookDetailsForReading__Paragraph"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BookDetailsForReading__Publication"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublicationDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicationId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BookDetailsForReading__Chapter"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublicationChapterDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paraId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"level"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BookDetailsForReading__Paragraph"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ParagraphDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paraId"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"refCodeShort"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]} as unknown as DocumentNode<GetBookDetailsForReadingQuery, GetBookDetailsForReadingQueryVariables>;
export const LoadContentChunkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LoadContentChunk"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"publicationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"elementId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publication"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"publicationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"publicationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paragraphs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"elementId"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BookDetailsForReading__Paragraph"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BookDetailsForReading__Paragraph"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ParagraphDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paraId"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"refCodeShort"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]} as unknown as DocumentNode<LoadContentChunkQuery, LoadContentChunkQueryVariables>;
export const AuthorSelector_ListAuthorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AuthorSelector_ListAuthors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AuthorSelector_PublicationAuthor"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AuthorSelector_PublicationAuthor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublicationAuthorDto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"middleName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]} as unknown as DocumentNode<AuthorSelector_ListAuthorsQuery, AuthorSelector_ListAuthorsQueryVariables>;